import Vue from 'vue';
const $t = Vue.i18n.translate;

export default () => [
    { value: null, text: $t('data.contactFormTypes.(Seleccionar)', '(Seleccionar)'), disabled: true },
    { value: "Consulta", text: $t('data.contactFormTypes.Consulta', 'Consulta') },
    { value: "Incidencia", text: $t('data.contactFormTypes.Incidencia', 'Incidencia') },
    { value: "Sugerencia", text: $t('data.contactFormTypes.Sugerencia', 'Sugerencia') },
];
